<!--  -->
<template>
  <div class="contaniner">
    <banner :type="type" :poster="poster" :currenTag="currentTag"></banner>
    <div class="news-content-box">
      <div class="top-wrapper">
        <div class="head-title">{{ dataInfo.title }}</div>
        <div class="head-desc">
          <div class="detail-desc">
            <div>发布时间: {{ declareTime }}</div>
            <div>来源：默尼科技</div>
          </div>
          <share
            class="share-item"
            v-if="isShare"
            ref="shareHook"
            :bdText="dataInfo.title"
            :bdDesc="dataInfo.summaryInfo"
            :bdUrl="bdUrl"
            :bdPic="bdPic"
          ></share>
        </div>
      </div>
      <div class="main-wrapper" v-html="dataInfo.content"></div>
      <route-btn
        :prevId="navBtn.prev.id"
        :prevTitle="navBtn.prev.title"
        :nextId="navBtn.next.id"
        :nextTitle="navBtn.next.title"
        :routerName="navBtn.routerName"
      ></route-btn>
    </div>
    <msg-box></msg-box>
    <top-arrow></top-arrow>
    <moni-footer></moni-footer>
  </div>
</template>

<script>
import banner from "../../components/banner/banner";
import moniFooter from "../../components/moniFooter/moniFooter";
import share from "../../components/share/share";
import msgBox from "../../components/msgBox/msgBox";
import topArrow from "../../components/topArrow/topArrow";
import routeBtn from "../../components/routeBtn/routeBtn";
import http from "../../api/http.js";
import apiUrl from "../../api/apiUrl.js";
import util from "../../api/util.js";
import "jquery";

export default {
  name: "newsPage",
  data() {
    return {
      type: "poster",
      poster: require("../../assets/images/banner5.png"),
      aHtml:
        '<p>ZXZxxxZxzX&nbsp;<img src="http://covteam.u.qiniudn.com/test21.jpg" alt="2442add7aed54770886c6e22475bf0c5.jpg"/></p>',
      navBtn: {
        routerName: "NewsPage",
        prev: { id: "", title: "" },
        next: { id: "", title: "" }
      },
      dataInfo: {},
      currentTag: -1,
      declareTime: "",
      bdPic: "http://covteam.u.qiniudn.com/test21.jpg",
      bdUrl: window.location.href,
      isShare: false
    };
  },

  props: [],

  mounted() {},

  watch: {
    $route: function(to, from) {
      if (to.name == "NewsPage") {
        $("html,body").animate({ scrollTop: 0 }, 500);
        this.fetchNewsDetailInfo();
        this.isShare = false;
      }
    }
  },

  components: {
    banner,
    moniFooter,
    share,
    msgBox,
    topArrow,
    routeBtn
  },

  computed: {},

  created() {
    $("html,body").animate({ scrollTop: 0 }, 500);
    this.fetchNewsDetailInfo();
  },

  methods: {
    fetchNewsDetailInfo() {
      const id = this.$route.query.newsId;
      http.get(apiUrl.newsDetail + id).then(response => {
        console.log(response);
        if (response.code == 0) {
          const data = response.data;
          this.dataInfo = data;
          const lastOnlineTime = data.lastOnlineTime;
          this.declareTime = util.formatTime(lastOnlineTime);
          this.navBtn.prev.id = data.prevnewsId;
          this.navBtn.prev.title = data.prevNewsTitle
            ? "上一篇: " + data.prevNewsTitle
            : "";
          this.navBtn.next.id = data.nextnewsId;
          this.navBtn.next.title = data.nextNewsTitle
            ? "下一篇: " + data.nextNewsTitle
            : "";
          this.isShare = true;
        }
      });
    },
    goShare() {
      const options = {
        bdText: this.dataInfo.title,
        bdDesc: this.dataInfo.summaryInfo,
        bdUrl: this.bdUrl,
        bdPic: this.bdPic
      };
      this.$refs.shareHook.goShare(options);
    }
  }
};
</script>

<!-- 富文本去除scoped-->
<style lang="scss">
.contaniner {
  .news-content-box {
    width: 100%;
    padding: 80px 350px 100px 350px;
    box-sizing: border-box;
    font-size: 20px;
    text-align: left;
    .top-wrapper {
      border-bottom: #ccc solid 2px;
      padding-bottom: 29px;
      .head-title {
        color: #333;
        font-size: 30px;
        line-height: 42px;
      }
      .head-desc {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 30px;
        color: #999;
        font-size: 16px;
        line-height: 22px;
        .detail-desc {
          display: flex;
          display: inline-block\0;
          div {
            display: inline-block\0;
            margin-right: 40px;
          }
        }
        .share-item {
          display: inline-block\0;
          float: right\0;
          vertical-align: middle\0;
        }
      }
    }
    .main-wrapper {
      font-size: 18px;
      line-height: 40px;
      p {
        margin-top: 15px;
        text-indent: 2em;
      }
      padding: 30px 0;
      border-bottom: #ccc dashed 1px;
    }
    .nav-wrapper {
      margin-top: 20px;
      display: flex;
      justify-content: space-between;
      font-size: 18px;
      line-height: 25px;
      color: #fbabc7;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/newsPage/newsPage.vue